import NavOptions from "components/Options/NavOptions";
import Settings from "components/Options/Settings";
import TableStyle from "components/Options/TableStyle";
import UserProfile from "components/UserProfile/UserProfile";
import "../assets/scss/orders.scss";

// import logo from "../assets/img/Designer.png"

import { useEffect, useState } from "react";

import API from "components/Apis/API";
import $ from "jquery";
import { useForm } from "react-hook-form";
import toast, { Toaster } from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";

import { useDispatch } from "react-redux";
import {
  AtRiskModel,
  ScheduledPickupInput,
  checkOldSkidCount,
  countCrossingandDocs,
  countHidden,
  countOrdersAtRisk,
  stringToColor,
} from "../components/Orders/helpers";
import {
  getOrderHistory,
  handleContactUpdate,
  makeProNumber
} from "../components/Warehouse/helpers";

import { Documents, FileUpload } from "../components/Orders/mxOrdersFiles";

// react-bootstrap components
import {
  Button,
  Container,
  Modal,
  Table
} from "react-bootstrap";

import { modifyOrder } from "components/Apis/orders";
import { getScraperStatus } from "components/Apis/scraper";
import { shortCurrencyFormatter } from "components/KPIs/helpers";
import DateTimeInput from "components/UI/Atoms/tableDatetimeInput";
import { BOLPrinter } from "components/Warehouse/modals/PrintBOL";
import { OrderNotes } from "components/Warehouse/rows/order";
import { useSelector } from "react-redux";
import { fetchLaneStatuses, fetchLanes } from "redux/warehouse/lanesSlice";
import { fetchTerminals } from "redux/warehouse/terminalSlice";

export const statusObjNB = {
  "En Route to Shipper": "12",
  "On-site at the Shipper": "25",
  "Loaded and En Route to Border": "37",
  "On-site at the Border": "50",
  "Pending Transfer": "56",
  "Crossing": "62",
  "MX Customs": "75",
  "US Customs": "87",
  "On-site at consignee": "100",
  "MX Portion Completed": "100",
  "Emergency": "0",
  "Hold": "0",
  "Cancelled": "0",
}

export const statusObjSB = {
  "Service Reported To Broker": "12",
  "Unit At Broker. Waiting Doda": "35",
  "Doda Ready. Waiting For Transfer": "37",
  "Crossing": "50",
  "At Nuevo Laredo. Waiting Dispatch": "62",
  "In Route To Destination": "75",
  "Arrived At Plant": "87",
  "MX Portion Completed": "100",
  "Cancelled": "0",
}

export const StatusObjIntra = {
  "En Route to Shipper": "12",
  "On-site at the Shipper": "25",
  "Loaded and En Route to Consignee": "65",
  "On-site": "90",
  "Completed": "100",
  "Emergency": "0",
  "Hold": "0",
  "Cancelled": "0",
}

const Orders = () => {
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [showMx, setShowMx] = useState(false);
  const [showProF, setShowProF] = useState(false);
  const [showBulkUpdate, setShowBulkUpdate] = useState(false);

  // selected terminal
  const [terminal, setTerminal] = useState(1);
  const [terminals, setTerminals] = useState([
    { name: "All", number: "all" },
    { name: "LRD NBB", number: 1 },
    { name: "CKV SBB", number: 2 },
    { name: "CKV NBB", number: 3 },
    { name: "DTW", number: 4 },
    { name: "DTW SB", number: 5 },
    { name: "Others", number: 0 },
    { name: "0 Miles", number: 6 },
    { name: "MX NB", number: 7 },
    { name: "MX SB", number: 8 },
    { name: "MX INTRA", number: 9 },
  ]);

  const MXTerminals = [7, 8, 9];

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseMx = () => setShowMx(false);
  const handleShowMx = () => setShowMx(true);

  const handleCloseProF = () => setShowProF(false);
  const handleShowProF = () => setShowProF(true);

  const handleCloseBulkUpdate = () => setShowBulkUpdate(false);
  const handleShowBulkUpdate = () => setShowBulkUpdate(true);

  const [check1, setCheck1] = useState(true);
  const [check2, setCheck2] = useState(false);
  const [check3, setCheck3] = useState(false);
  const [check4, setCheck4] = useState(false);
  const [check5, setCheck5] = useState(false);
  const [check6, setCheck6] = useState(false);
  const [check7, setCheck7] = useState(false);

  const [checkF1, setCheckF1] = useState(true);
  const [checkF2, setCheckF2] = useState(false);
  const [checkF3, setCheckF3] = useState(false);
  const [checkF4, setCheckF4] = useState(false);
  const [checkF5, setCheckF5] = useState(false);
  const [checkF6, setCheckF6] = useState(false);
  const [checkF7, setCheckF7] = useState(false);

  let history = useHistory();

  const [orders, setOrders] = useState([]);
  const [order, setOrder] = useState([]);
  const [hidden, setHidden] = useState(0);
  const [showHidden, setShowHidden] = useState(0);
  const [dimensions, setDimensions] = useState([]);
  const [proF, setProF] = useState([]);
  const [selectedCount, setselectedCount] = useState(0);

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  const location = useLocation();
  const queryParams = new URLSearchParams(window.location.search);

  const [loadsCrossing, setLoadsCrossing] = useState(0);
  const [mxDocsReady, setMxDocsReady] = useState(0);
  const [ordersAtRisk, setOrdersAtRisk] = useState(0);
  const [showOrdersAtRisk, setShowOrdersAtRisk] = useState(false);


  const lanes = useSelector((state) => state.lanes);

  const { lanesStatusesLoading, lanesStatusesError, data: lanesStatuses } = useSelector((state) => state.lanes.laneStatuses)

  const laneStatus = lanesStatuses?.find((s) => s.number == terminal);
  useEffect(() => {
    if (!lanes.lanes) {
      dispatch(fetchLanes());
    }
    dispatch(fetchLaneStatuses())
  }, []);

  const allTerminals = useSelector((state) => state.TerminalSlice);
  useEffect(() => {
    if (!allTerminals.terminals || allTerminals.terminals.length === 0) {
      dispatch(fetchTerminals());
    }
  }, []);
  console.log(allTerminals);

  const fetchData = async () => {
    let tid = 1;
    let hid = localStorage.getItem("hidden");
    if (queryParams.get("terminal")) {
      tid = queryParams.get("terminal");
      setTerminal(tid);
    }

    const toastId = toast.loading("Loading data...");
    const url = "" + "admin/get_orders";
    const token = await UserProfile.getToken();

    let formData = new FormData();
    formData.append("terminal", tid);
    formData.append("hidden", hid);
    const response = await API.postData(url, formData);
    const data = response;
    if (data.status) {
      setOrders(data.data);
      if (tid === 1 || tid === "1") {
        countCrossingandDocs(data.data, setLoadsCrossing, setMxDocsReady);
      }
      countHidden(data.data, setHidden);
      countOrdersAtRisk(data.data, setOrdersAtRisk);
    }

    toast.dismiss(toastId);
    $(".tbtn").removeClass("active");
    $(".terminal_" + tid).addClass("active");

    if (hid == 1) {
      $(".toggleHidden").addClass("active");
      setShowHidden(1);
    } else {
      setShowHidden(0);
    }
    //init datatable
    NavOptions.initDataTable(tid);
  };

  const fetchOrder = async (id, mx = false) => {
    const toastId = toast.loading("Loading data...");
    const url = "" + "admin/get_order";
    const token = await UserProfile.getToken();

    let formData = new FormData();
    formData.append("id", id);
    const response = await API.postData(url, formData);
    const data = response;
    if (data.status) {
      const obj = data.data[0];
      console.log(obj.mx_documents);
      setCheck1(obj.mx_documents.includes("Carta"));
      setCheck2(obj.mx_documents.includes("DODA"));
      setCheck3(obj.mx_documents.includes("Prefile"));
      setCheck4(obj.mx_documents.includes("FOLIO"));
      setCheck5(obj.mx_documents.includes("BOND"));
      setCheck6(obj.mx_documents.includes("CI"));
      setCheck7(obj.mx_documents.includes("VIATPRO"));
      await checkMxDocuments();

      await setOrder(data.data[0]);
      if (mx) {
        await handleShowMx();
      } else {
        await handleShow();
      }
    }

    toast.dismiss(toastId);
    //await getDimensions(obj.id);
  };

  const getDimensions = async (id) => {
    const toastId = toast.loading("Fetching missing data...");
    const url = "" + "admin/get_order_dimensions";
    const token = await UserProfile.getToken();

    let formData = new FormData();
    formData.append("id", id);
    const response = await API.postData(url, formData);
    const data = response;
    if (data.status == true) {
      $(".stackableSelect").val(data.data.stackable);
      $(".dockSelect").val(data.data.dock);
      setOrder((current) => {
        return {
          ...current,
          width: data.data.width,
          skids: data.data.units,
          weight: data.data.weight,
          length: data.data.length,
          height: data.data.height,
          stackable: data.data.stackable,
          pro_f: data.data.pro_f,
          total_length: data.data.total_length,
          dock: data.data.dock,
          customer: data.data.customer,
          customer_reference: data.data.customer_reference,
        };
      });
    } else {
      toast.error(data.msg);
      handleClose();
      fetchData();
    }

    toast.dismiss(toastId);
  };

  const updateLength = async (e) => {
    order[e.target.name] = e.target.value;
    await setOrder((current) => {
      return {
        ...current,
        [e.target.name]: e.target.value,
      };
    });

    await calculateLength();
  };
  const calculateLength = async () => {
    var newLength = 0;

    if (order.width < 100) {
      if (order.stackable == "Yes") {
        newLength = Math.round(order.skids / Math.floor(110 / order.height));
      } else {
        newLength = order.skids;
      }

      newLength = newLength / Math.floor(100 / order.width);
      if (newLength < 1) {
        newLength = 1;
      }
      newLength = Math.round(newLength) * order.length;
    } else {
      newLength = order.skids * order.length;
    }
    await setOrder((current) => {
      return {
        ...current,
        total_length: newLength,
      };
    });
  };


  const syncData = async () => {
    let tid = 1;
    if (queryParams.get("terminal")) {
      tid = queryParams.get("terminal");
      setTerminal(tid);
    }

    const formData = new FormData();
    formData.append("terminal", tid);
    // const toastId = toast.loading("Syncing data...");
    const url = "" + "scrapper/pull/data";
    const token = await UserProfile.getToken();

    const response = await API.postData(url, formData);
    if (response.status) {
      toast.success(response.msg);
      await delay(1000);
    } else {
      toast.error(response.msg);
    }
    const toastId = toast.loading("Scraper is running...");
    while ((await getScraperStatus()).data.msg == "Scraper is busy") {
      await delay(1500);
    }
    toast.dismiss(toastId);
    toast.success("Scraper finished!");
  };

  const updateOrder = async (data) => {
    const toastId = toast.loading("Updating data...");
    const url = "" + "admin/update_order/" + order.id;
    const token = await UserProfile.getToken();
    const formData = new FormData($(".singleOrderForm")[0]);
    formData.append("total_length", order.total_length);
    formData.append("scheduled_pickup", order.scheduled_pickup);
    const response = await API.postData(url, formData);
    const rsp = response;
    if (rsp.status) {
      fetchData(terminal);
      toast.dismiss(toastId);
      toast.success(rsp.msg);
      handleClose();
    } else {
      toast.dismiss(toastId);
      toast.error("Failed to update records!");
    }
  };

  const updateOrderMx = async () => {
    const toastId = toast.loading("Updating order...");
    const url = "" + "admin/update_order_mx/" + order.id;
    const token = await UserProfile.getToken();
    const formData = new FormData($(".singleOrderFormMx")[0]);
    let mx_documents = [];
    $("input[name='mx_documents[]']").each(function (i, obj) {
      if (
        $(obj).val() != "" &&
        $(obj).is(":checked") &&
        $(obj).is(":not(:disabled)")
      ) {
        mx_documents.push($(obj).val());
      }
    });
    let text = mx_documents.join("|");
    formData.append("mx_documents", text);

    const response = await API.postData(url, formData);
    const rsp = response;
    if (rsp.status) {
      if (
        $(".singleOrderFormMx select[name=mx_status]").val() ==
        "MX Portion Completed" ||
        $(".singleOrderFormMx select[name=mx_status]").val() == "Cancelled"
      ) {
        $(".order_id_" + order.id).remove();
      } else {
        fetchData(terminal);
      }
      toast.dismiss(toastId);
      toast.success(rsp.msg);
      handleCloseMx();
    } else {
      toast.dismiss(toastId);
      toast.error("Failed to update records!");
    }
  };

  const changeTerminal = async (id) => {
    history.replace("/admin/orders?terminal=" + id);
    window.location.reload();
  };
  const changeStackable = async (event) => {
    setOrder((current) => {
      return {
        ...current,
        stackable: event.target.value,
      };
    });
  };
  const checkMxDocuments = async (e) => {
    // if($("#check2").is(':checked') && $("#check3").is(':checked'))
    // {
    //   await setCheck1(false);
    //   $("#check1").attr("disabled",true);
    // }
    // else
    // {
    //   $("#check1").attr("disabled",false);
    // }
  };

  const getOrderF = async (pro_f) => {
    event.preventDefault();
    const toastId = toast.loading("Loading data...");
    const url = "" + "admin/get_order_f";
    const token = await UserProfile.getToken();

    let formData = new FormData();
    formData.append("pro_f", pro_f);
    const response = await API.postData(url, formData);
    const data = response;
    const obj = data.data[0];
    if (data.status == true) {
      await setProF(obj);
      setCheckF1(obj.mx_documents.includes("Carta"));
      setCheckF2(obj.mx_documents.includes("DODA"));
      setCheckF3(obj.mx_documents.includes("Prefile"));
      handleShowProF();
    } else {
      toast.error("Reference order does not exist!");
    }

    toast.dismiss(toastId);
  };

  const bulkUpdate = async () => {
    const toastId = toast.loading("Saving data...");
    const url = "" + "admin/update_orders_bulk";
    const token = await UserProfile.getToken();
    const formData = new FormData($(".bulkUpdateForm")[0]);
    formData.append("scheduled_pickup", order["scheduled_pickup"]);
    formData.append("ids", JSON.stringify(selectedRows));
    formData.append("terminal", terminal);

    const response = await API.postData(url, formData);
    const data = response;
    const obj = data.data[0];
    if (data.status == true) {
      toast.success("Orders updated!");
    } else {
      toast.error("Reference order does not exist!");
    }
    toast.dismiss(toastId);
  };

  const mxChangeEmail = async (event, id) => {
    const toastId = toast.loading("Updating data...");
    const url = "" + "admin/update_order_email/" + id;
    const token = await UserProfile.getToken();

    const response = await API.postData(url, {});
    const rsp = response;
    if (rsp.status) {
      toast.dismiss(toastId);
      console.log(event.currentTarget);
      $(".email_btn_" + id).toggleClass("mx_email_sent");
    } else {
      toast.dismiss(toastId);
      toast.error("Failed to update records!");
    }
  };
  const hasSearchText = (text, subtext) => {
    return text.includes(subtext);
  };

  const [showOrderHistory, setShowOrderHistory] = useState(false);
  const [orderProNumber, setOrderProNumber] = useState("");
  const [orderHistoryData, setOrderHistoryData] = useState([]);
  const launchUpdateByModal = (row) => {
    setOrderProNumber(makeProNumber(row));
    setShowOrderHistory(true);
    getOrderHistory(
      row.id,
      showOrderHistory,
      setShowOrderHistory,
      setOrderHistoryData
    );
  };
  const closeOrderHistoryModal = () => setShowOrderHistory(false);

  const makeYellow = (value) => {
    return value && value.length > 0
      ? {}
      : { backgroundColor: "rgba(255,255,0,.7)" };
  };

  const makeRed = (value) => {
    return value < 636 ? {} : { backgroundColor: "rgba(255, 0, 0, 0.7)" };
  };

  const addHourForEasternTime = (dropDead) => {
    const dateObject = new Date(dropDead);
    if (terminal === "4" || terminal === "5") {
      dateObject.setHours(dateObject.getHours() + 1);
    }
    return dateObject;
  };

  const checkScheduledPickup = (scheduledPickup, dropDead) => {
    const dropDeadDateObject = addHourForEasternTime(dropDead);
    const scheduledPickupDateObject = new Date(scheduledPickup);
    try {
      if (!scheduledPickup) {
        return { backgroundColor: "rgba(255, 255, 0, 0.7)" };
      } else if (dropDeadDateObject < scheduledPickupDateObject) {
        return { backgroundColor: "rgba(255, 0, 0, 0.7)" };
      } else {
        return {};
      }
    } catch {
      return {};
    }
  };

  const askComplete = async (order) => {
    toast(
      (t) => (
        <span style={{ textAlign: "center" }}>
          Another bus completed !!?<br></br>
          <button
            className="btn btn-primary btn-xs"
            onClick={() => {
              modifyOrder(
                {
                  id: order.id,
                  action: "load"
                }
              )
            }}
          >
            👍 Yes
          </button>
          <button
            className="btn btn-primary btn-xs"
            onClick={() => toast.dismiss(t.id)}
          >
            👎 Hmm, Not Yet
          </button>
        </span>
      ),
      { icon: "👏" }
    );
  };

  const pushToStarboard = async (id) => {
    const toastId = toast.loading("Pushing order, this will take a while ...");

    const url = "" + "admin/push_order_to_starboard";
    const token = await UserProfile.getToken();

    let formData = new FormData();
    formData.append("id", id);

    const response = await API.postData(url, formData);
    const rsp = response;
    toast.success(rsp.msg);
    toast.dismiss(toastId);
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const toggleHidden = async () => {
    let current = localStorage.getItem("hidden");
    if (current == 1) {
      localStorage.setItem("hidden", 0);
    } else {
      localStorage.setItem("hidden", 1);
    }
    window.location.reload();
  };

  const selectRow = (index) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(index)) {
        return prevSelectedRows.filter((i) => i !== index);
      } else {
        return [...prevSelectedRows, index];
      }
    });
  };

  const statusInfo =
    terminal !== "7" && terminal !== 7 && terminal !== "8" && terminal !== 8 & String(terminal) != "9" ? (
      <span
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginLeft: "10px",
          flexWrap: "wrap",
          gap: "12px"
        }}
      >
        {(terminal === "1" || terminal == 1) && (
          <>
            <span style={{ fontSize: "14px" }}>
              Crossing: {loadsCrossing}
            </span>
            <span>
              |
            </span>
            <span style={{ fontSize: "14px" }}>
              Crossing Documents Ready: {mxDocsReady}
            </span>
            <span>
              |
            </span>
          </>
        )}
        <span style={{ fontSize: "14px" }}>
          At Risk Scheduled Pickup: {ordersAtRisk}{" "}
          {showOrdersAtRisk ? (
            <i
              style={{ cursor: "pointer" }}
              onClick={() => setShowOrdersAtRisk(!showOrdersAtRisk)}
              className="fa fa-minus"
            ></i>
          ) : (
            <i
              style={{ cursor: "pointer" }}
              onClick={() => setShowOrdersAtRisk(!showOrdersAtRisk)}
              className="fa fa-plus"
            ></i>
          )}
        </span>
      </span>
    ) : (
      <></>
    );


  useEffect(() => {
    fetchData(1);
  }, []);

  const llanes = [
    { id: 7, name: "NB", number: 1, region: "LRD" },
    { id: 9, name: "NB", number: 3, region: "CKV" },
    { id: 8, name: "SB", number: 2, region: "CKV" },
    { id: 5, name: "L", number: 4, region: "DTW" },
    { id: 6, name: "SB", number: 5, region: "DTW" },
    { id: 3, name: "NB", number: 7, region: "MX" },
    { id: 1, name: "INTRA", number: 9, region: "MX" },
    { id: 2, name: "SB", number: 8, region: "MX" },
  ];

  const groupedLanes = llanes.reduce((acc, t) => {
    acc[t.region] = [...(acc[t.region] || []), t];
    return acc;
  }, {});


  return (
    <>
      <Toaster position="bottom-right" />
      <Container fluid className="orders-container">
        <div className="d-flex flex-row w-100 orders-main-section-buttons-wrapper justify-content-between align-items-start mb-3">
          {/* Terminal Buttons */}
          <div className="flex-column">
            {["LRD", "CKV", "DTW", "MX"].map((region) => (
              <>
                <span
                  className={`warehouse-main-header ${llanes.find((llane) => String(terminal) === String(llane?.number))?.region === region
                    ? "selected"
                    : ""
                    }`}
                >
                  {region}
                </span>

                {groupedLanes[region]?.map(({ id, name, number }) => {
                  const status = lanesStatuses?.find((s) => s.id === id);
                  const faults = status?.order_faults_count || 0;
                  const isActive = String(terminal) === String(number);
                  const showSpinner = !lanesStatuses || lanesStatusesLoading;

                  return (
                    <button
                      key={id}
                      onClick={() => changeTerminal(number)}
                      className={`warehouse-main-header ${isActive ? "warehouse-active" : ""}`}
                    >
                      {name}
                      {region === "MX" ? (
                        <>
                          {showSpinner ? (
                            <span className="badge counter-badge">
                              <i className="fa fa-spinner fa-spin"></i>
                            </span>) : (
                            <span className="badge counter-badge">
                              {status.active_orders_count}
                            </span>
                          )}
                        </>
                      ) : showSpinner ? (
                        <span className="badge counter-badge">
                          <i className="fa fa-spinner fa-spin"></i>
                        </span>
                      ) : faults === 0 ? (
                        <span className="badge counter-badge bg-success">
                          <i className="fa fa-smile"></i>
                        </span>
                      ) : (
                        <span className="badge counter-badge bg-danger">{faults}</span>
                      )}
                    </button>
                  );
                })}
              </>
            ))}

            <span className="warehouse-main-header">Filters</span>
            <button
              onClick={() => changeTerminal("all")}
              className={`warehouse-main-header ${String(terminal) === "all" ? "warehouse-active" : ""}`}
            >
              Unfiltered
            </button>
            <button
              onClick={() => changeTerminal(6)}
              className={`warehouse-main-header ${String(terminal) === "6" ? "warehouse-active" : ""}`}
            >
              0 Miles
            </button>
            <button
              onClick={() => changeTerminal(0)}
              className={`warehouse-main-header ${String(terminal) === "0" ? "warehouse-active" : ""}`}
            >
              Direct
              <>
                <span className="badge counter-badge">
                  {!lanesStatuses || lanesStatusesLoading ? (
                    <>
                      <i className="fa fa-spinner fa-spin"></i>
                    </>
                  ) : (
                    <>
                      {lanesStatuses?.find((s) => s.short_form_name == "Direct")?.active_orders_count}
                    </>
                  )}
                </span>
              </>
            </button>
          </div>

          {/* Action Buttons */}
          <div className="flex-column">
            <span className="warehouse-main-header">Actions</span>
            <button onClick={syncData} className="warehouse-main-header">Sync</button>
            {/* <button onClick={toggleHidden} className="warehouse-main-header">
              Show Hidden ({hidden})
            </button> */}
            <button
              onClick={(e) => NavOptions.toggleSelectAll(e, orders, setSelectedRows)}
              className="warehouse-main-header"
            >
              Check
            </button>
            <button onClick={handleShowBulkUpdate} className="warehouse-main-header">
              Update
            </button>
          </div>
        </div>
        <div className="orders-status-info">
          {statusInfo}
          {laneStatus?.terminal && (
            <span
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "12px",
              }}
            >
              | <span>Unassigned Orders: {laneStatus?.unassigned_orders_count}</span>
              | <span>Late For Pickup: {laneStatus?.orders_late_for_pickup_count}</span>
            </span>

          )}
        </div>
        <hr style={{ marginLeft: 0, marginRight: 0 }} />
        <div className="datatableContainer d-flex flex-row">
          {!MXTerminals.includes(parseInt(terminal)) ? (
            <table className="allOrders row-border shadow">
              <thead className="bg-dark text-white">
                <tr>
                  {terminal == "1" ? <th className="border-0">Vehicle</th> : ""}
                  {
                    terminal != "1" && terminal != 0 ?
                      <th className="border-0">Inbound</th> : ""
                  }
                  <th className="border-0">Pro (B)</th>
                  <th className="border-0">Team</th>
                  <th className="border-0">Skids</th>
                  <th className="border-0">Total Length</th>
                  <th className="border-0">Weight (lbs)</th>
                  {terminal != "1" ? <th className="border-0">Vehicle</th> : ""}
                  {terminal == 0 ? (
                    <th className="border-0">Pickup Time</th>
                  ) : (
                    ""
                  )}
                  {terminal == "0" ? (
                    <th className="border-0">Pickup At</th>
                  ) : (
                    ""
                  )}
                  <th className="border-0">Deliver Time</th>
                  <th className="border-0">Deliver To</th>
                  {terminal == "1" ? (
                    <th className="border-0">MX Status</th>
                  ) : (
                    ""
                  )}
                  {terminal == "1" ? (
                    <th className="border-0">MX Documents</th>
                  ) : (
                    ""
                  )}
                  {
                    terminal == 0 ?
                      <></>
                      :
                      <>
                        <th className="border-0">On Dock</th>
                        <th className="border-0">Outbound</th>
                        <th className="border-0">Scheduled Pickup</th>
                      </>
                  }
                  <th className="border-0">Stop / Notes</th>
                  {["1", "2", "3", "4", "5"].includes(String(terminal)) && <th className="border-0">GP</th>}
                  <th className="border-0">Dist. (Miles)</th>
                  <th className="border-0">Drop Dead</th>
                  <th className="border-0">Act.</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((row, i) => (
                  <tr
                    key={i}
                    className={`order_id_${row.id
                      } ${TableStyle.getNonMXRowClasses(row)}
                          ${showHidden == 0 && row.hidden == 1 ? "hidden" : ""} 
                          ${selectedRows.includes(row.id)
                        ? "order-row-selected"
                        : ""
                      }`}
                    onDoubleClick={() => selectRow(row.id)}
                  >
                    {terminal == "1" ? <td>{row.vehicle_size}</td> : ""}
                    {
                      terminal != "1" && terminal != 0 ?
                        (<td style={makeYellow(row.inbound)}>
                          {row.inbound}
                        </td>
                        ) : (
                          ""
                        )
                    }
                    <td>
                      {row.order_no} {row.order_group}
                      <br></br>
                      {row.pro_f}
                    </td>
                    <td>
                      {row.reference_3}
                      {row.dispatch_board != "" ? (
                        <span
                          className={
                            row.dispatch_board == "HOT BOARD"
                              ? "badge badge-danger"
                              : ""
                          }
                        >
                          {" "}
                          ({row.dispatch_board})
                        </span>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>
                      {row.units}
                      {checkOldSkidCount(row)}
                    </td>
                    <td style={makeRed(row.total_length)}>
                      {row.total_length}
                    </td>
                    <td>{row.weight}</td>
                    {terminal != "1" ? <td>{row.vehicle_size}</td> : ""}
                    {
                      terminal == 0 &&
                      <>
                        <td>{row.pickup_date}</td>
                      </>
                    }
                    {terminal == "0" ? <td>{row.pickup_at}</td> : ""}
                    <td>{row.delivery_date}</td>
                    <td>{row.deliver_to}</td>
                    {terminal == "1" ? (
                      <td>
                        <span
                          className={
                            row.mx_status_ref == "On-site at the Border"
                              ? "badge badge-success"
                              : ""
                          }
                        >
                          {row.mx_status_ref}
                        </span>
                      </td>
                    ) : (
                      ""
                    )}
                    {terminal == "1" ? (
                      <td
                        className={
                          (row.mx_documents_ref.length > 2 &&
                            row.mx_documents_ref != 0
                            ? "cyellow"
                            : "") +
                          " " +
                          (row.mx_documents_ref.includes("DODA") &&
                            row.mx_documents_ref.includes("Prefile")
                            ? "cgreen"
                            : "cred")
                        }
                      >
                        {row.mx_documents_ref}
                      </td>
                    ) : (
                      ""
                    )}
                    {
                      terminal == 0
                        ?
                        <>
                        </>
                        : <>
                          <td>
                            <span className={TableStyle.GetStatusClasses(row)}>
                              {row.dock}
                            </span>
                          </td>
                          <td style={makeYellow(row.bus)}>
                            <span
                              className={TableStyle.CheckEmptyClasses(row.bus)}
                            >
                              {" "}
                              <span
                                style={{
                                  backgroundColor: row.terminal == 4 ? stringToColor(row.bus) : "",
                                  fontWeight: "bold",
                                  fontSize: "11px",
                                  padding: "3px",
                                  borderRadius: "5px",
                                }}
                              >
                                {`${row.bus}`}
                              </span>
                            </span>
                            {row.trailer_number && (
                              <span className="text-danger text-uppercase font-weight-bold">
                                {` | ${row.trailer_number}`}
                              </span>
                            )}
                          </td>
                          <td
                            style={checkScheduledPickup(
                              row.scheduled_pickup,
                              row.drop_dead
                            )}
                          >
                            {row.scheduled_pickup
                              ? new Date(row.scheduled_pickup)
                                .toLocaleDateString(undefined, {
                                  month: "2-digit",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                })
                                .replace(/[/]/g, "-")
                              : ""}
                          </td>
                        </>
                    }
                    <td>
                      <div className="d-flex flex-column align-items-center">
                        <span
                          className={
                            terminal == 1 &&
                              (row.stop == "AA" || row.stop == "DROP")
                              ? "badge badge-warning"
                              : ""
                          }
                        >
                          {row.stop}
                        </span>
                        <div>
                          <OrderNotes order={row} />
                        </div>
                      </div>
                    </td>
                    {["1", "2", "3", "4", "5"].includes(String(terminal)) && (
                      <td>
                        <span className={(row.grossmargin?.gross_profit <= 0) ? "badge badge-pill badge-danger" : ""}>
                          {shortCurrencyFormatter(
                            row.grossmargin?.gross_profit ? row.grossmargin.gross_profit : 0
                          )}
                        </span>
                        <br />
                        {/* {row.grossmargin?.margin? Math.round(row.grossmargin.margin) : 0}% */}
                      </td>
                    )}
                    <td>{row.distance}</td>
                    <td>
                      <span className={Settings.checkDropDead(row.drop_dead)}>
                        {row.drop_dead}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-primary btn-xs"
                        onClick={() => fetchOrder(row.id)}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                      {row.terminal == "1" && row.pro_f != "" ? (
                        <button
                          className="btn btn-primary btn-xs"
                          onClick={() => getOrderF(row.pro_f)}
                        >
                          <i className="fa fa-link"></i>
                        </button>
                      ) : (
                        ""
                      )}
                      {(!row.outgoing_bus && row.bus && (row.unloaded === 1)) && (
                        <button
                          className="btn btn-primary btn-xs"
                          style={{ background: "red" }}
                          onClick={() => askComplete(row)}
                        >
                          <i className="fa fa-check"></i>
                        </button>
                      )}
                      <button
                        className="btn btn-primary btn-xs"
                        onClick={() => pushToStarboard(row.id)}
                        title="Push To Starboard"
                      >
                        <i className="fa fa-upload"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            ""
          )}
          {MXTerminals.includes(parseInt(terminal)) ? (
            <table className="allOrders row-border">
              <thead className="bg-dark text-white">
                <tr>
                  <th className="border-0">Pro (B)</th>
                  <th className="border-0">MX Carrier</th>
                  <th className="border-0">Transfer</th>
                  <th className="border-0">Team</th>
                  <th className="border-0">Trailer /Placas</th>
                  {terminal === "8" || terminal === "9" ? (
                    <th className="border-0">Contact</th>
                  ) : (
                    ""
                  )}
                  <th className="border-0">Vehicle</th>
                  <th className="border-0">Pickup At</th>
                  {(terminal == "8" || terminal == "9") ? <th className="border-0">Broker</th> : ""}
                  <th className="border-0">Deliver To</th>
                  <th className="border-0">Consignee</th>
                  <th className="border-0">Pick Up Date</th>
                  <th className="border-0">Delivery Date</th>
                  <th className="border-0">Customer</th>
                  <th className="border-0">Customer Reference</th>
                  <th className="border-0">Overall Progress</th>
                  {terminal != "9" && (<th className="border-0">Docs.</th>)}
                  {terminal === "7" && (<th className="border-0">Crossing ETA</th>)}
                  <th className="border-0">Action</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((row, i) => (
                  <tr
                    key={i}
                    className={`${TableStyle.getRowClasses(row, statusObjSB)}
                            ${selectedRows.includes(row.id)
                        ? "order-row-selected"
                        : ""
                      }`}
                    onDoubleClick={() => selectRow(row.id)}
                  >
                    <td>
                      {row.order_no} {row.order_group}
                      <br></br>
                      {row.pro_f}
                    </td>
                    <td>{row.mx_carrier}</td>
                    <td>{row.transfer}</td>
                    <td>
                      <span className={TableStyle.GetTeamClasses(row)}>
                        {row.mx_team}
                      </span>
                    </td>
                    <td>{row.trailer_placas}</td>
                    {(terminal == "8" || terminal == "9") ? (
                      <td>
                        <span className={TableStyle.GetStatusClasses(row)}>
                          <div className="d-flex flex-column align-items-center">
                            <input
                              name="contacts"
                              type="text"
                              className="form-control notesInput"
                              placeholder="Enter contact"
                              defaultValue={row.dock}
                              onBlur={(e) => {
                                const newContact = e.target.value;
                                handleContactUpdate(row.id, newContact);
                              }}
                            />
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => launchUpdateByModal(row)}
                            >
                              Updated by{" "}
                              {
                                row.updated_by_username?.startsWith("atiq")
                                  ? "System"
                                  : row.updated_by_username?.split("@")[0]
                              }
                            </span>
                          </div>
                        </span>
                      </td>
                    ) : (
                      ""
                    )}
                    <td>{row.vehicle_size}</td>
                    <td>{row.pickup_at}</td>
                    {(terminal == "8" || terminal == "9") ? <td>{row.mx_broker}</td> : ""}
                    <td>{row.deliver_to}</td>
                    <td>{row.consignee_name}</td>
                    <td>{row.pickup_date}</td>
                    <td>{row.delivery_date}</td>
                    <td>{row.customer}</td>
                    <td>{row.customer_reference}</td>
                    <td>
                      <div className="progress">
                        {terminal == 7 ? (
                          <div
                            className={TableStyle.GetProgressBarClasses(
                              statusObjNB[row.mx_status]
                            )}
                            role="progressbar"
                            style={{
                              width:
                                (statusObjNB[row.mx_status]
                                  ? statusObjNB[row.mx_status]
                                  : 0) + "px",
                            }}
                            aria-valuenow={
                              statusObjNB[row.mx_status]
                                ? statusObjNB[row.mx_status]
                                : 0
                            }
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            {statusObjNB[row.mx_status]
                              ? statusObjNB[row.mx_status]
                              : 0}
                            %
                          </div>
                        ) : terminal == 8 ? (
                          <div
                            className={TableStyle.GetProgressBarClasses(
                              statusObjSB[row.mx_status]
                            )}
                            role="progressbar"
                            style={{
                              width:
                                (statusObjSB[row.mx_status]
                                  ? statusObjSB[row.mx_status]
                                  : 0) + "px",
                            }}
                            aria-valuenow={
                              statusObjSB[row.mx_status]
                                ? statusObjSB[row.mx_status]
                                : 0
                            }
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            {statusObjSB[row.mx_status]
                              ? statusObjSB[row.mx_status]
                              : 0}
                            %
                          </div>
                        ) : (
                          <div
                            className={TableStyle.GetProgressBarClasses(
                              StatusObjIntra[row.mx_status]
                            )}
                            role="progressbar"
                            style={{
                              width:
                                (StatusObjIntra[row.mx_status]
                                  ? StatusObjIntra[row.mx_status]
                                  : 0) + "px",
                            }}
                            aria-valuenow={
                              StatusObjIntra[row.mx_status]
                                ? StatusObjIntra[row.mx_status]
                                : 0
                            }
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            {StatusObjIntra[row.mx_status]
                              ? StatusObjIntra[row.mx_status]
                              : 0}
                            %
                          </div>
                        )}
                      </div>
                      {row.mx_status}
                    </td>
                    {
                      terminal != "9" && (
                        <td>
                          {row.mx_documents.split("|").map((substring, index) => {
                            return substring === "Carta Porte" &&
                              row.mx_doda_date ? (
                              <span
                                style={{ whiteSpace: "pre-line" }}
                                className={TableStyle.GetDocumentsClasses(row)}
                              >
                                {`${substring}\n(${row.mx_doda_date})`}
                              </span>
                            ) : (
                              <span className={TableStyle.GetDocumentsClasses(row)}>
                                {substring}
                              </span>
                            );
                          })}
                        </td>
                      )
                    }
                    {
                      terminal == 7 && (
                        <td>
                          <DateTimeInput
                            defaultValue={row.border_crossing_date}
                            onChange={(newValue) => modifyOrder(
                              {
                                id: row.id,
                                border_crossing_date: newValue,
                              }
                            )}
                            className="custom-datetime-input"
                          />
                        </td>
                      )
                    }
                    <td>
                      <button
                        className="btn btn-primary btn-xs"
                        onClick={() => fetchOrder(row.id)}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                      {MXTerminals.includes(parseInt(terminal)) ? (
                        <button
                          className="btn btn-primary btn-xs"
                          onClick={() => fetchOrder(row.id, true)}
                        >
                          <i className="fa fa-cog"></i>
                        </button>
                      ) : (
                        ""
                      )}

                      {MXTerminals.includes(parseInt(terminal)) ? (
                        <a
                          className={
                            "btn btn-xs mx_email email_btn_" +
                            row.id +
                            " " +
                            (row.mx_email == 1 ? "mx_email_sent" : "")
                          }
                          onClick={(e) => mxChangeEmail(e, row.id)}
                        >
                          <i className="fa fa-envelope"></i>
                        </a>
                      ) : (
                        ""
                      )}
                      {row.terminal == "8" || row.terminal == "9" && (
                        <BOLPrinter order={row} size='m-1 px-1 py-0' />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            ""
          )}
        </div>
      </Container>
      <Modal show={show} onHide={handleClose} className=" ">
        <Modal.Header>
          <Modal.Title style={{ width: "100%", margin: "0 0 0" }}>
            Adding Missing Data{" "}
            <button
              style={{ float: "right" }}
              className="btn btn-primary btn-sm"
              onClick={() => getDimensions(order.id)}
            >
              Refresh Order Data
            </button>
            <br></br>
            <span className="reference-order-span">
              Master Pro# {order.master_pro}
            </span>
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(updateOrder)} className="singleOrderForm">
          <Modal.Body style={{ paddingTop: "10px" }}>
            <Table
              className="table-hover table-striped"
              style={{ width: "100%", margin: "0 0 0" }}
            >
              <tbody>
                <tr>
                  <th>Pro#</th>
                  <td>
                    {order.order_no} {order.order_group}
                  </td>

                  <th>Back Pro#</th>
                  <td>
                    {order.pro_f}
                  </td>
                </tr>
                <tr>
                  <th>Inbound</th>
                  <td>
                    <input
                      name="inbound"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter inbound"
                      value={order.inbound}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    />
                  </td>

                  <th>
                    <span className={TableStyle.GetLengthClasses(order.length)}>
                      Length
                    </span>
                  </th>
                  <td>
                    <input
                      name="length"
                      type="number"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter length"
                      value={order.length}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <th>
                    <span className={TableStyle.GetLengthClasses(order.width)}>
                      Width
                    </span>
                  </th>
                  <td>
                    <input
                      name="width"
                      type="number"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter width"
                      value={order.width}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    />
                  </td>

                  <th>Height</th>
                  <td>
                    <input
                      name="height"
                      type="number"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter height"
                      value={order.height}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Stackable</th>
                  <td>
                    <select
                      defaultValue={order.stackable}
                      name="stackable"
                      onChange={(e) => {
                        updateLength(e);
                      }}
                      className="form-control mt-1 modalInput stackableSelect"
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </td>

                  <th>Outbound</th>
                  <td>
                    <input
                      name="bus"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter outbound"
                      defaultValue={order.bus}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <th>
                    Dock{" "}
                    <span style={{ fontSize: ".8em" }}>
                      {terminal === "5" || terminal === "4" ? "(EST)" : ""}
                    </span>
                  </th>
                  <td>
                    <input
                      name="dock"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="On dock?"
                      defaultValue={order.dock}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    />
                  </td>

                  <th>Stop:</th>
                  <td>
                    {/* <input
                      name="stop"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter stop"
                      defaultValue={order.stop}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    /> */}
                    <select
                      defaultValue={order.forward_connection_terminal_id}
                      name="forward_connection_terminal_id"
                      className="form-control mt-1 modalInput"
                      placeholder="Select stop"
                    >
                      <option value="">
                        ---
                      </option>
                      {
                        allTerminals.terminals
                          .filter(
                            (t) => !t.lanes.map((l) => String(l.number)).includes(String(order.terminal))
                          )
                          .map((t) => (
                            <option
                              key={`${t.id}-terminal-top-option`}
                              value={t.id}
                            >
                              {t.name}
                            </option>
                          ))
                      }
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>Skids</th>
                  <td>
                    <input
                      name="skids"
                      type="number"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter skids"
                      value={order.skids}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    />
                  </td>

                  <th>Weight (lbs)</th>
                  <td>
                    <input
                      name="weight"
                      type="number"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter weight"
                      value={order.weight}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <th>
                    <span
                      className={TableStyle.GetTotalLengthClasses(
                        order.total_length
                      )}
                    >
                      Total Length
                    </span>
                  </th>
                  <td>
                    <span
                      className="totalLength"
                      onClick={(e) => {
                        calculateLength();
                      }}
                    >
                      {order.total_length}
                    </span>
                  </td>

                  <th>Terminal</th>
                  <td>
                    <select
                      defaultValue={order.terminal}
                      name="terminal"
                      className="form-control mt-1 modalInput"
                    >
                      {
                        lanes.lanes?.map((lane) => (
                          <option value={lane.number}>{lane.short_form_name}</option>
                        ))
                      }
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>
                    Scheduled Pickup:{" "}
                    <span style={{ fontSize: ".8em" }}>
                      {terminal === "5" || terminal === "4" ? "(EST)" : ""}
                    </span>
                  </th>
                  <ScheduledPickupInput
                    scheduledPickup={order.scheduled_pickup}
                    updateLength={updateLength}
                  />
                  {terminal === "7" || terminal === "8" ? (
                    <>
                      <th>Notes</th>
                      <td style={{ width: "180px" }}>
                        <textarea
                          className="form-control"
                          name="mx_notes"
                          defaultValue={order.mx_notes}
                          placeholder="Notes"
                        ></textarea>
                      </td>
                    </>
                  ) : (
                    <>
                      <th>PT</th>
                      <td>
                        <input
                          className="form-control mt-1 modalInput"
                          name="trailer_number"
                          defaultValue={order.trailer_number}
                          placeholder="Trailer Number"
                          onChange={(e) => {
                            updateLength(e);
                          }}
                        ></input>
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  <th>Master Pickup At</th>
                  <td colSpan={3}>
                    {order.master_pickup_at}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal
        show={showMx}
        onHide={handleCloseMx}
        className="bd-example-modal-lg"
      >
        <Modal.Header>
          <Modal.Title style={{ width: "100%", margin: "0 0 0" }}>
            Adding Missing Data{" "}
            <button
              style={{ float: "right" }}
              className="btn btn-primary btn-sm"
              onClick={() => getDimensions(order.id)}
            >
              Refresh Order Data
            </button>
          </Modal.Title>
        </Modal.Header>
        <form
          onSubmit={handleSubmit(updateOrderMx)}
          className="singleOrderFormMx"
        >
          <Modal.Body style={{ paddingTop: "10px" }}>
            <Table
              className="table-hover table-striped"
              style={{ width: "100%", margin: "0 0 0" }}
            >
              <tbody>
                <tr>
                  <th>Customer Reference No#:</th>
                  <td>
                    <input
                      name="customer_reference"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter customer reference"
                      value={order.customer_reference}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    />
                  </td>

                  <th>Customer:</th>
                  <td>
                    <input
                      name="customer"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter inbound"
                      value={order.customer}
                      onChange={(e) => {
                        updateLength(e);
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <th>MX Carrier:</th>
                  <td>
                    <input
                      name="mx_carrier"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter MX carrier"
                      defaultValue={order.mx_carrier}
                    />
                  </td>

                  <th>Transfer:</th>
                  <td>
                    <input
                      name="transfer"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter transfer"
                      defaultValue={order.transfer}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Trailer/Placas:</th>
                  <td>
                    <input
                      name="trailer_placas"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Trailer/placas"
                      defaultValue={order.trailer_placas}
                    />
                  </td>

                  <th>Status:</th>
                  <td>
                    <select
                      defaultValue={order.mx_status}
                      name="mx_status"
                      className="form-control mt-1 modalInput"
                    >
                      {terminal == 7
                        ? Object.entries(statusObjNB).map(function (row, key) {
                          return <option>{row[0]}</option>;
                        })
                        : terminal == 8
                          ? Object.entries(statusObjSB).map(function (row, key) {
                            return <option>{row[0]}</option>;
                          })
                          : terminal == 9
                            ? Object.entries(StatusObjIntra).map(function (row, key) {
                              return <option>{row[0]}</option>;
                            })
                            : <></>
                      }
                    </select>
                  </td>
                </tr>
                {
                  MXTerminals.includes(parseInt(terminal)) && (
                    <tr>
                      <th>Seal:</th>
                      <td colSpan={3}>
                        <input
                          name="seal"
                          type="text"
                          className="form-control mt-1 modalInput"
                          placeholder="Seal"
                          defaultValue={order.seal}
                        />
                      </td>
                    </tr>
                  )
                }
                {
                  terminal != "9" && (
                    <tr>
                      <th>Documents:</th>
                      <td colSpan={3}>
                        <table className="table">
                          <tbody>
                            <tr>
                              <td>
                                <input
                                  onChange={(e) => {
                                    checkMxDocuments(e);
                                  }}
                                  name="mx_documents[]"
                                  defaultChecked={check1}
                                  id="check1"
                                  className="form-check-input"
                                  type="checkbox"
                                  value="Carta Porte"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="check1"
                                >
                                  Carta Porte
                                </label>
                                <input
                                  name="mx_doda_date"
                                  type="date"
                                  className=""
                                  placeholder="DODA expiry date"
                                  defaultValue={order.mx_doda_date}
                                  style={{ marginLeft: "25px", height: "25px" }}
                                />
                              </td>
                              <td>
                                <Documents
                                  order={order}
                                  documentType={"Carta Porte"}
                                ></Documents>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  onChange={(e) => {
                                    checkMxDocuments(e);
                                  }}
                                  name="mx_documents[]"
                                  defaultChecked={check2}
                                  id="check2"
                                  className="form-check-input"
                                  type="checkbox"
                                  value="DODA"
                                />

                                <label
                                  className="form-check-label"
                                  htmlFor="check2"
                                >
                                  DODA
                                </label>
                              </td>
                              <td>
                                <Documents
                                  order={order}
                                  documentType={"DODA"}
                                ></Documents>
                              </td>
                            </tr>
                            {terminal == 7 ? (
                              <>
                                <tr>
                                  <td>
                                    <input
                                      onChange={(e) => {
                                        checkMxDocuments(e);
                                      }}
                                      name="mx_documents[]"
                                      defaultChecked={check3}
                                      id="check3"
                                      className="form-check-input"
                                      type="checkbox"
                                      value="Prefile"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="check3"
                                    >
                                      Prefile
                                    </label>
                                  </td>
                                  <td>
                                    <Documents
                                      order={order}
                                      documentType={"Prefile"}
                                    ></Documents>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <input
                                      onChange={(e) => {
                                        checkMxDocuments(e);
                                      }}
                                      name="mx_documents[]"
                                      defaultChecked={check4}
                                      id="check4"
                                      className="form-check-input"
                                      type="checkbox"
                                      value="FOLIO"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="check4"
                                    >
                                      FOLIO
                                    </label>
                                  </td>
                                  <td>
                                    <Documents
                                      order={order}
                                      documentType={"FOLIO"}
                                    ></Documents>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <input
                                      onChange={(e) => {
                                        checkMxDocuments(e);
                                      }}
                                      name="mx_documents[]"
                                      defaultChecked={check5}
                                      id="check5"
                                      className="form-check-input"
                                      type="checkbox"
                                      value="BOND"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="check5"
                                    >
                                      BOND
                                    </label>
                                  </td>
                                  <td>
                                    <Documents
                                      order={order}
                                      documentType={"BOND"}
                                    ></Documents>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <input
                                      onChange={(e) => {
                                        checkMxDocuments(e);
                                      }}
                                      name="mx_documents[]"
                                      defaultChecked={check6}
                                      id="check6"
                                      className="form-check-input"
                                      type="checkbox"
                                      value="CI"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="check6"
                                    >
                                      CI
                                    </label>
                                  </td>
                                  <td>
                                    <Documents
                                      order={order}
                                      documentType={"CI"}
                                    ></Documents>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <input
                                      onChange={(e) => {
                                        checkMxDocuments(e);
                                      }}
                                      name="mx_documents[]"
                                      defaultChecked={check7}
                                      id="check7"
                                      className="form-check-input"
                                      type="checkbox"
                                      value="VIATPRO"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="check7"
                                    >
                                      VIATPRO
                                    </label>
                                  </td>
                                  <td>
                                    <Documents
                                      order={order}
                                      documentType={"VIATPRO"}
                                    ></Documents>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <input
                                      onChange={(e) => {
                                        checkMxDocuments(e);
                                      }}
                                      name="mx_documents[]"
                                      defaultChecked={
                                        (order.length > 0 && order.mx_documents.includes("Manifest"))
                                      }
                                      id="Manifest"
                                      className="form-check-input"
                                      type="checkbox"
                                      value="Manifest"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="Manifest"
                                    >
                                      Manifest
                                    </label>
                                  </td>
                                  <td>
                                    <Documents
                                      order={order}
                                      documentType={"Manifest"}
                                    ></Documents>
                                  </td>
                                </tr>
                              </>
                            ) : (
                              ""
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )
                }
                <tr>
                  <th>Notes</th>
                  <td style={{ width: "150px" }}>
                    <textarea
                      className="form-control"
                      name="mx_notes"
                      defaultValue={order.mx_notes}
                      placeholder="Notes"
                    ></textarea>
                  </td>

                  <th>Team:</th>
                  <td>
                    <select
                      defaultValue={order.mx_team}
                      name="mx_team"
                      className="form-control mt-1 modalInput"
                    >
                      {terminal == 7 ? (
                        <>
                          <option>RXO</option>
                          <option>AAMG</option>
                          <option>MX Customers</option>
                        </>
                      ) : (
                        <>
                          <option>FORD</option>
                          <option>GM</option>
                          <option>LEAR</option>
                          <option>ACTIVE-GPO LOG</option>
                          <option>MX CUSTOMS</option>
                        </>
                      )}
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>Broker:</th>
                  <td>
                    <input
                      name="mx_broker"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Broker"
                      defaultValue={order.mx_broker}
                    />
                  </td>
                </tr>
                <tr>
                  <FileUpload order={order}></FileUpload>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseMx}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal
        show={showProF}
        onHide={handleCloseProF}
        className=" bd-example-modal-lg"
      >
        <Modal.Header>
          <Modal.Title style={{ width: "100%", margin: "0 0 0" }}>
            Reference Order Data<br></br>
            <span className="reference-order-span">
              (Order No#: {proF.order_no} | Terminal:{" "}
              {
                terminals.find((terminal) => terminal.number == proF.terminal)
                  ?.name
              }
              )
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ paddingTop: "10px" }}>
          <Table
            className="table-hover table-striped"
            style={{ width: "100%", margin: "0 0 0" }}
          >
            <tbody>
              <tr>
                <th>Customer Reference No#:</th>
                <td>
                  <input
                    name="customer_reference"
                    type="text"
                    className="form-control mt-1 modalInput"
                    placeholder="Enter customer reference"
                    value={proF.customer_reference}
                    onChange={(e) => {
                      updateLength(e);
                    }}
                  />
                </td>

                <th>Customer:</th>
                <td>
                  <input
                    name="customer"
                    type="text"
                    className="form-control mt-1 modalInput"
                    placeholder="Enter inbound"
                    value={proF.customer}
                    onChange={(e) => {
                      updateLength(e);
                    }}
                  />
                </td>
              </tr>
              <tr>
                <th>MX Carrier:</th>
                <td>
                  <input
                    name="mx_carrier"
                    type="text"
                    className="form-control mt-1 modalInput"
                    placeholder="Enter MX carrier"
                    defaultValue={proF.mx_carrier}
                  />
                </td>

                <th>Transfer:</th>
                <td>
                  <input
                    name="transfer"
                    type="text"
                    className="form-control mt-1 modalInput"
                    placeholder="Enter transfer"
                    defaultValue={proF.transfer}
                  />
                </td>
              </tr>
              <tr>
                <th>Trailer/Placas:</th>
                <td>
                  <input
                    name="trailer_placas"
                    type="text"
                    className="form-control mt-1 modalInput"
                    placeholder="Trailer/placas"
                    defaultValue={proF.trailer_placas}
                  />
                </td>

                <th>Status:</th>
                <td>
                  <select
                    defaultValue={proF.mx_status}
                    name="mx_status_f"
                    className="form-control mt-1 modalInput"
                  >
                    {
                      terminal == 7
                        ? Object.entries(statusObjNB).map(function (row, key) {
                          return <option>{row[0]}</option>;
                        }
                        ) : terminal == 8 ?
                          Object.entries(statusObjSB).map(function (row, key) {
                            return <option>{row[0]}</option>;
                          }
                          ) :
                          Object.entries(StatusObjIntra).map(function (row, key) {
                            return <option>{row[0]}</option>;
                          })}
                  </select>
                </td>
              </tr>
              <tr>
                <th>Documents:</th>
                <td colSpan={3}>
                  <table className="table">
                    <tbody>
                      <tr>
                        <td>
                          <input
                            onChange={(e) => {
                              checkMxDocuments(e);
                            }}
                            name="mx_documents[]"
                            defaultChecked={checkF1}
                            id="checkF1"
                            className="form-check-input"
                            type="checkbox"
                            value="Carta Porte"
                          />
                          <label className="form-check-label" htmlFor="check1">
                            Carta Porte
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            onChange={(e) => {
                              checkMxDocuments(e);
                            }}
                            name="mx_documents[]"
                            defaultChecked={checkF2}
                            id="checkF2"
                            className="form-check-input"
                            type="checkbox"
                            value="DODA"
                          />
                          <label className="form-check-label" htmlFor="check2">
                            DODA
                          </label>
                        </td>
                      </tr>
                      {terminal == 7 ? (
                        <>
                          <tr>
                            <td>
                              <input
                                onChange={(e) => {
                                  checkMxDocuments(e);
                                }}
                                name="mx_documents[]"
                                defaultChecked={checkF3}
                                id="checkF3"
                                className="form-check-input"
                                type="checkbox"
                                value="Prefile"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="check3"
                              >
                                Prefile
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                onChange={(e) => {
                                  checkMxDocuments(e);
                                }}
                                name="mx_documents[]"
                                defaultChecked={check4}
                                id="check4"
                                className="form-check-input"
                                type="checkbox"
                                value="FOLIO"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="check4"
                              >
                                FOLIO
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                onChange={(e) => {
                                  checkMxDocuments(e);
                                }}
                                name="mx_documents[]"
                                defaultChecked={check5}
                                id="check5"
                                className="form-check-input"
                                type="checkbox"
                                value="BOND"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="check5"
                              >
                                BOND
                              </label>
                            </td>
                          </tr>
                        </>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <th>Notes</th>
                <td>
                  <textarea
                    className="form-control"
                    name="mx_notes"
                    defaultValue={proF.mx_notes}
                    placeholder="Notes"
                  ></textarea>
                </td>

                <th>Team:</th>
                <td>
                  <select
                    defaultValue={proF.mx_team}
                    name="mx_team"
                    className="form-control mt-1 modalInput"
                  >
                    <option>RXO</option>
                    <option>AAMG</option>
                    <option>MX Customers</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseProF}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showBulkUpdate}
        onHide={handleCloseBulkUpdate}
        className=" bd-example-modal-lg"
      >
        <form onSubmit={handleSubmit(bulkUpdate)} className="bulkUpdateForm">
          <Modal.Header>
            <Modal.Title style={{ width: "100%", margin: "0 0 0" }}>
              Bulk Update
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ paddingTop: "10px" }}>
            <Table
              className="table-hover table-striped"
              style={{ width: "100%", margin: "0 0 0" }}
            >
              <tbody>
                <tr>
                  <th>Inbound:</th>
                  <td>
                    <input
                      name="inbound"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter inbound"
                    />
                  </td>
                  <th>Bus:</th>
                  <td>
                    <input
                      name="bus"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter bus"
                    />
                  </td>
                </tr>
                <tr>
                  <th>On Dock:</th>
                  <td>
                    <input
                      name="dock"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="On dock?"
                    />
                  </td>
                  <th>Stop:</th>
                  <td>
                    <select
                      defaultValue={null}
                      name="forward_connection_terminal_id"
                      className="form-control mt-1 modalInput"
                      placeholder="Select stop"
                    >
                      <option value="">
                        ---
                      </option>
                      {
                        allTerminals.terminals
                          .filter((t) => !(t.lanes.map((l) => String(l.number)).includes(String(terminal))))
                          .map((terminal) => (
                            <option value={terminal.id}>
                              {terminal.name}
                            </option>
                          ))
                      }
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>Scheduled Pickup:</th>
                  <ScheduledPickupInput
                    scheduledPickup={order.scheduled_pickup}
                    updateLength={updateLength}
                  />
                  <th>Hide/Show:</th>
                  <td>
                    <select className="form-control" name="hidden">
                      <option></option>
                      <option value="1">Hide</option>
                      <option value="0">Show</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseBulkUpdate}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <AtRiskModel
        showModal={showOrdersAtRisk}
        setShowModal={setShowOrdersAtRisk}
        terminal={terminal}
      />
    </>
  );
};

export default Orders;
